import { ToastProvider } from '@aimsos/ui';
import { useTranslation } from '@aimsos/i18n';
import WorkQueue from './domains/work-queue';

/**
 * Root component of the Work Queues application.
 *
 * Embed-only app: the Core Shell owns the BrowserRouter, Auth0Provider and
 * ThemeProvider. ToastProvider is mounted here so general actions (Ask,
 * Escalate, Skip) can raise toasts in both embedded and standalone modes.
 */
const WorkQueuesApp = () => {
  const { t, ready } = useTranslation('work-queues-app');

  if (!ready) {
    return (
      <div className="flex flex-1 items-center justify-center text-sm text-content-muted">
        {t('common.loading')}
      </div>
    );
  }

  return (
    <ToastProvider config={{ position: 'top-right', defaultDuration: 4000 }}>
      <div className="flex h-full flex-1 flex-col overflow-hidden">
        <WorkQueue />
      </div>
    </ToastProvider>
  );
};

export default WorkQueuesApp;
